/**
 * 组件相关接口
 */

import { fetchApi } from "../interceptor"
import Qs from "qs"

const V2 = "v2"

/**
 * 根据组件类型查询组件列表
 * @param {*} data
 * typeId=组件类型id
 * p=pageNum
 * p2=pageSize  p2=1时，查询的组件会返回content，其它情况都不会返回content
 * k 进行搜索的内容
 * lsc=true查询当前分类和子分类的组件，false查询时，只查询当前分类下的组件，不会再查子分类
 */
export const queryComponentList = data => {
  const url = `${V2}/type/${data.typeId}/list-enc`
  const param = {
    p: data.p,
    p2: data.p2,
    lsc: data.lsc,
    k: typeof data.k !== 'undefined'? data.k : ''
  }
  return fetchApi(url, param, "GET", "params")
}

/**
 * 组件encId查询组件content
 * @param {*} data
 * encId=组件encId
 */
export const queryComponentContent = data => {
  const url = `${V2}/module-content/${data.encId}/get`
  const param = {
    a: data.a,
    all: data.all
  }
  return fetchApi(url, param, "GET", "params")
}
/**
 * 获取通栏的指定分类下的第一个数据
 */
export const queryFirstComponentContent = data => {
  const url = `${V2}/module-content/fst?t=${data.encId}`
  return fetchApi(url, null, "POST", "params")
}

/**
 * 拖拽组件，返回该类型组件的默认组件，该接口只做查询，不会克隆任何数据
 * @param {*} data
 * t=组件类型id
 */
export const queryDefaultComponent = data => {
  const url = `${V2}/drag`
  const param = {
    t: data.t
  }
  return fetchApi(url, param, "GET", "params")
}

/**
 * 删除组件对应的应用及权限
 */
export const deleteComponentApp = data => {}

/**
 * 查询树形结构的组件类型
 * pid 必须【组件类型module_type的publicId】传0时，返回全部树形结构
 * k 搜索内容
 * countSub 非必须【count分类下的组件数量】默认false，true时，返回的分类下会有count字段，表示该分类下的组件数量
 */
export const queryComponentTypeTree = data => {
  let url = `module-type/${data.pid?data.pid:0}/list-enc2`
  if (data.countSub) url += `?countSub=${data.countSub}`
  if (data.countSub) url = typeof data.k !== 'undefined'? `${url}&k=${data.k}` : url
  return fetchApi(url, null, "GET", "params")
}

/**
 * 生成应用
 * a 必须【大屏是前端写死的encId，需要用DES解码；2.0是获取的appPublicId】
 * 特殊用法：a2 非必须【moduleContent的appId属性可能和content里的i0不同，不同时，取content里的i0做a2，当作真实的appPublicId替换a（这里加a2参数，是因为a不能直接改，存在写死的情况）】
 * p 必须【编辑页地址栏上的p参数，页面page的publicId】
 * t  非必须【组件名称】
 * c 必须【content 样式的pc端json】
 * c2 非必须【封面】
 * c3 必须【content 样式的app端json】
 * clone  非必须【同一个页面复制应用使用】默认false
 * t2 必须【组件所属的组件类型ID，module_type的publicId】
 */
export const createComponentApp = data => {
  const url = `${V2}/app-and-module`
  return fetchApi(url, data.param, "POST", "data")
}

/**
 * 修复脏数据应用
 * 这个方法可以克隆任意应用，不限制pageId和websiteId。仅用于修复脏数据
 * /v2/app-and-module-for-repair
 * 耗时578ms
 * 请求方式：post
 * 请求参数：
 * a 必须【应用的appPublicId】
 * p 必须【编辑页地址栏上的p参数，页面page的publicId】
 * t  非必须【组件名称】
 * c 必须【content 样式的pc端json】
 * c2 非必须【封面】
 * c3 必须【content 样式的app端json】
 * clone  非必须【同一个页面复制应用使用】默认false
 * t2 必须【组件所属的组件类型ID，module_type的publicId】
 */
export const repairDirtyDataApp = data => {
  const url = `${V2}/app-and-module-for-repair?isClone=${data.isClone}`
  return fetchApi(url, data.param, "POST", "data")
}

/**
 * 生成系统组件
 * t2 必须【组件所属的组件类型ID，module_type的publicId】
 *
 * p 必须【编辑页地址栏上的p参数，页面page的publicId】
 * w 必须【编辑页地址栏上的w参数，页面website的publicId】
 *
 * c 必须【content 样式的pc端json】
 * c3 必须【content 样式的app端json】
 *
 * a 必须【engineInstance的appPublicId】
 *
 * ma 非必须【是否通栏组件】默认false
 * t 非必须【组件名称】
 * c2 非必须【封面】
 */
export const createSystemComponentApp = data => {
  const url = `${V2}/add-module-enc`
  return fetchApi(url, data.param, "POST", "data")
}

/**
 * 我的收藏查询接口
 * 按照分类查看
 * 必须 传一个数组，数组中的元素可为逗号隔开的多个分类publicId，
 * "其他" 这个分类需要先确定展示那些具体分类的数据，然后再把这些分类id用逗号隔开传参
 *
 */
export const collectListsType = data => {
  const url = `module-type/list-by-type-ids-tree`
  return fetchApi(url, data.param, "POST", "body")
}
/**
 * 我的收藏查询接口
 * 不按照分类查询
 * 传所有需要查询的分类id
 * p=pageNum
 * p2=pageSize
 */
export const collectListsAll = data => {
  const url = `module-type/list-by-type-ids?typeIds=${data.typeIds}&pageNum=${data.p}&pageSize=${data.p2}`
  return fetchApi(url, null, "GET", "params")
}
/**
 * 按照分类查询时查看更多
 * 加一个ts参数传对应的分类id，可传多个
 * p=pageNum
 * p2=pageSize
 */
export const collectListsTypeMore = data => {
  let url = `${V2}/type/0/list-enc?ts=${data.typeIds}&p=${data.p}&p2=${data.p2}`
  url = typeof data.k !== 'undefined'? `${url}&k=${data.k}` : url
  return fetchApi(url, null, "GET", "params")
}
/**
 * 修改收藏组件的封面和名称
 * 传所有需要查询的分类id
 * p=pageNum
 * p2=pageSize
 */
export const collectCoverNameChange = data => {
  const url = `${V2}/update-module-content/${data.publicId}?title=${data.title}`
  return fetchApi(url, null, "GET", "params")
}

/**
 * 生成系统组件
 * t2 必须【组件所属的组件类型ID，module_type的publicId】
 *
 * p 必须【编辑页地址栏上的p参数，页面page的publicId】
 * w 必须【编辑页地址栏上的w参数，页面website的publicId】
 *
 * c 必须【content 样式的pc端json】
 * c3 必须【content 样式的app端json】
 *
 * a 必须【engineInstance的appPublicId】
 *
 * ma 非必须【是否通栏组件】默认false
 * t 非必须【组件名称】
 * c2 非必须【封面】
 *
 *
 * 此接口为新改造的通栏设为系统样式模块的接口，调用方式、参数和add-module-enc接口使用一样
 * 调clone-add-module-enc的话就不用调app-and-module了，appId也不用替换，传老的就行
 */
export const createSystemComponentAppClone = data => {
  const url = `${V2}/clone-add-module-enc`
  return fetchApi(url, data.param, "POST", "data")
}

/**
 * 组件encId查询组件content
 * @param {*} data
 * encId=组件encId
 * 此接口为新改造的获取通栏样式应用接口，和以前module-content/{id}/get 这个一样 ，加了一个p参数
 */
export const queryComponentContentClone = data => {
  const url = `${V2}/module-content/${data.encId}/get-and-clone?p=${data.p}`
  const param = {
    a: data.a,
    all: data.all,
    ct: data.ct
  }
  return fetchApi(url, param, "GET", "params")
}
